module.exports = __webpack_public_path__ + "static/loader-4cc848b538580780aa52b50a7a18e1fa.gif";